import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { isPcpLiveSessionToken, PcpLiveSessionToken } from '../interfaces/live-lesson-token';

@Injectable({
    providedIn: 'root',
})
export class PcpLiveTokenDecoder {

    constructor(private readonly jwt: JwtHelperService) { }

    decodeToken(rawToken: string): PcpLiveSessionToken {
        const decodedToken = this.jwt.decodeToken<PcpLiveSessionToken>(rawToken);

        if (!decodedToken || !isPcpLiveSessionToken(decodedToken)) {
            throw 'Invalid token';
        }

        return decodedToken;
    }
}
